import React from "react";

const DraftMcqType = () => {
  return (
    <>
      {/* <div className="create-q-all">
        <div class=" main-Q1 mb-3 col-12">
          <div className="Question-no">Q1</div>
          <div className="Options_box-main ">
            Lorem Ipsum é um texto modelo da indústria tipográfica e de
            impressão.
          </div>
          <div className="three-dots">
            <img src="images/three dot hr.svg" alt=""></img>
          </div>
        </div>

        <div className="dropdown-Q mb-3">
          <div id="inner-dropdown">
            <select
              class="form-select pt-2 pb-2 "
              aria-label="Default select example"
            >
              <option selected>Knowledge Domain</option>
              <option value="1">Factual Knowledge</option>
              <option value="2">Conceptual Knowledge</option>
              <option value="3">Procedural Knowledge</option>
            </select>
          </div>
          <div id="inner-dropdown">
            <select
              class="form-select pt-2 pb-2"
              aria-label="Default select example"
            >
              <option selected>Skills</option>
              <option value="1"> Remembering</option>
              <option value="2">Understanding</option>
              <option value="3">Applying</option>
              <option value="3">Analysis</option>
              <option value="3">Evaluation</option>
              <option value="3">Creation</option>
            </select>
          </div>
          <div id="inner-dropdown">
            <select
              class="form-select pt-2 pb-2"
              aria-label="Default select example"
            >
              <option selected>Question Type</option>
              <option value="1">McqType</option>
              <option value="2">Open input Field</option>
              <option value="3">Upload a file</option>
              <option value="3">Fill in the blank</option>
            </select>
          </div>
          <div id="inner-dropdown">
            <select
              class="form-select pt-2 pb-2"
              aria-label="Default select example"
            >
              <option selected>Chapter</option>
              <option value="1">Chapter-1</option>
              <option value="2">Chapter-2</option>
              <option value="3">Chapter-3</option>
            </select>
          </div>
        </div>

        <div className="mandatory-row ">
          <div className="mandatory col-2">
            <input
              class="form-check-input"
              type="checkbox"
              value=""
              id="flexCheckDefault"
            />
            <label class="form-check-label" for="flexCheckDefault">
              Mandatory question
            </label>
          </div>
          <div className="attach-all col-5">
            <div className="attach_section">
              <input type="file" id="attachFile" style={{ display: "none" }} />
              <label className="AttachIcon" htmlFor="attachFile">
                <img className="attach_icon" src="/images/Attach.svg" alt="" />

                <span className="attach">Attach</span>
              </label>
            </div>
          </div>
        </div>

        <div className="img">
          <img src="images/image-type-q.png" class="img-fluid" alt="..." />
        </div>

        <div className="all-options">
          <div class=" main-Qptions mb-3 col-12">
            <div className="option-no">A</div>
            <div className="Options_box-options">Answer option- 01</div>
            <div className="dustbin">
              <img src="images/Dustbin.svg" alt=""></img>
            </div>
          </div>
          <div class=" main-Qptions mb-3 col-12">
            <div className="option-no">B</div>
            <div className="Options_box-options">Answer option- 02</div>
            <div className="dustbin">
              <img src="images/Dustbin.svg" alt=""></img>
            </div>
          </div>
          <div class=" main-Qptions mb-3 col-12">
            <div className="option-no">C</div>
            <div className="Options_box-options">Answer option- 03</div>
            <div className="dustbin">
              <img src="images/Dustbin.svg" alt=""></img>
            </div>
          </div>
          <div class="main-Qptions mb-3 col-12">
            <div className="option-no">D</div>
            <div className="Options_box-options">Answer option- 04</div>
            <div className="dustbin">
              <img src="images/Dustbin.svg" alt=""></img>
            </div>
          </div>
        </div>

        <div>
          <div className="ml-3 mb-3 col-12">
            <div className="select-ans ml-1 mb-2">
              Select the correct answer
            </div>

            <div className="Options_box-options">Answer option- 04</div>
          </div>
        </div>
      </div> */}
    </>
  );
};

export default DraftMcqType;
